import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "card",
  style: {"height":"86vh"}
}
const _hoisted_2 = { class: "pt-4 text-start" }
const _hoisted_3 = { class: "fw-bolder d-flex align-items-center text-dark text-center justify-content-center" }
const _hoisted_4 = {
  key: 0,
  class: "d-flex justify-content-center"
}
const _hoisted_5 = { class: "w-100" }
const _hoisted_6 = { class: "card mb-10" }
const _hoisted_7 = { class: "fv-row" }
const _hoisted_8 = { class: "row justify-content-center" }
const _hoisted_9 = { class: "col-10" }
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = { class: "col-12 text-center mt-4" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "indicator-label" }
const _hoisted_14 = { class: "indicator-progress" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MapComponentOL = _resolveComponent("MapComponentOL")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h5", _hoisted_3, _toDisplayString(_ctx.$t("selectWhereTheIncidentOcurred")), 1)
    ]),
    (
        _ctx.incidentsImagesList.length > 0 &&
        _ctx.router.currentRoute.value.name === 'add-incident'
      )
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "btn btn-primary btn-sm rounded-pill mx-2",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setImage(null)))
          }, _toDisplayString(_ctx.$t("noImage")), 1),
          _createElementVNode("button", {
            class: "btn btn-primary btn-sm rounded-pill mx-2",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setImage(_ctx.incidentsImagesList[0].UUID)))
          }, _toDisplayString(_ctx.$t("imageNearest")), 1),
          (_ctx.incidentsImagesList.length > 1)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn btn-primary btn-sm rounded-pill mx-2",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setImage(_ctx.incidentsImagesList[1].UUID)))
              }, _toDisplayString(_ctx.$t("imageFar")), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_component_MapComponentOL, {
      mapid: "map1",
      ref: "theMap",
      key: 0,
      incidentsArray: _ctx.incidentsArray,
      siteViewParameters: _ctx.siteViewParameters,
      mapViewToSet: _ctx.mapView,
      maxLoadedImages: 15,
      imageIsLoading: _ctx.imageIsLoading,
      showButtons: false,
      imageDict: _ctx.imageData,
      showImage: _ctx.showImage,
      currentSelectMode: _ctx.mode,
      editedIncidentId: _ctx.listIncidents[0].Id,
      onViewChanged: _ctx.setMapView,
      onClickedCoordinates: _ctx.coordinateReceived
    }, null, 8, ["incidentsArray", "siteViewParameters", "mapViewToSet", "imageIsLoading", "imageDict", "showImage", "currentSelectMode", "editedIncidentId", "onViewChanged", "onClickedCoordinates"])),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("textarea", {
                type: "textarea",
                class: "form-control",
                placeholder: _ctx.$t('leaveAnObservation'),
                name: "observations",
                id: "comments",
                style: {"height":"100px"},
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.myprops.incidentData.value.incident.Comments) = $event))
              }, null, 8, _hoisted_10), [
                [_vModelText, _ctx.myprops.incidentData.value.incident.Comments]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("button", {
            class: "btn btn-lg btn-dark w-20 mb-5 me-15",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.goToPreviousStep && _ctx.goToPreviousStep(...args)))
          }, _toDisplayString(_ctx.$t("goBack")), 1),
          _createElementVNode("button", {
            class: "btn btn-lg btn-primary w-25 mb-5",
            disabled: 
              _ctx.myprops.incidentData.value.incident.X == null ||
              _ctx.myprops.incidentData.value.incident.Y == null
            ,
            onClick: _cache[5] || (_cache[5] = ($event: any) => (
              _ctx.router.currentRoute.value.name === 'add-incident'
                ? _ctx.saveIncident()
                : _ctx.editIncident()
            ))
          }, [
            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.router.currentRoute.value.name === "add-incident"
                  ? _ctx.$t("saveIncident")
                  : _ctx.$t("saveChanges")), 1),
            _createElementVNode("span", _hoisted_14, [
              _createTextVNode(_toDisplayString(_ctx.$t("pleaseWait")) + " ", 1),
              _hoisted_15
            ])
          ], 8, _hoisted_12)
        ])
      ])
    ])
  ]))
}